export { default } from "./GoogleMap"
